import {
  Play,
  Users,
  Webhook,
  Shield,
  DollarSign,
  Infinity as InfinityIcon,
  Sparkles,
  Rocket,
} from "lucide-react";
import { BriefcaseIcon } from "@heroicons/react/outline";
import { isValidElement } from "react";

import { PlanFeatures as PlanFeaturesType } from "./constants";

import { Agent, Dataset, Evaluation, Prompt, RequestLog } from "@/components/icons";

interface PlanFeaturesProps {
  features: PlanFeaturesType;
}

const getFeatureIcon = (featureName: string) => {
  const name = featureName.toLowerCase();
  if (name.includes("prompt")) {
    return Prompt;
  }
  if (name.includes("request")) {
    return RequestLog;
  }
  if (name.includes("workflow")) {
    return Agent;
  }
  if (name.includes("eval")) {
    return Evaluation;
  }
  if (name.includes("playground")) {
    return Play;
  }
  if (name.includes("user")) {
    return Users;
  }
  if (name.includes("dataset")) {
    return Dataset;
  }
  if (name.includes("workspace")) {
    return BriefcaseIcon;
  }
  if (name.includes("deployment")) {
    return Rocket;
  }
  if (name.includes("webhook")) {
    return Webhook;
  }
  if (name.includes("rbac")) {
    return Shield;
  }
  if (name.includes("overage")) {
    return DollarSign;
  }

  return Sparkles;
};

const ValueBadge = ({ value }: { value: string | JSX.Element | undefined }) => {
  if (!value) {
    return null;
  }

  if (isValidElement(value)) {
    return <div className="flex items-center">{value}</div>;
  }

  const strValue = String(value);
  const lowerValue = strValue.toLowerCase();

  if (lowerValue === "unlimited") {
    return (
      <div className="flex items-center gap-1">
        <InfinityIcon className="h-3 w-3 text-gray-500" />
      </div>
    );
  }

  if (lowerValue === "-" || lowerValue === "none") {
    return <span className="text-xs text-gray-400">—</span>;
  }

  return <span className="text-xs font-semibold text-gray-700">{strValue}</span>;
};

export const PlanFeatures = ({ features }: PlanFeaturesProps) => (
  <div className="mb-4 flex flex-col gap-1 overflow-y-auto pr-1">
    {Object.entries(features).map(([feature, value]) => {
      const Icon = getFeatureIcon(feature);

      return (
        <div key={feature} className="flex h-[24px] items-center justify-between gap-2">
          <div className="flex min-w-0 flex-1 items-center gap-2">
            <Icon className="h-3.5 w-3.5 flex-shrink-0 text-gray-400" strokeWidth={2} />
            <span className="truncate text-xs text-gray-600">{feature}</span>
          </div>

          <div className="flex-shrink-0">
            <ValueBadge value={value} />
          </div>
        </div>
      );
    })}
  </div>
);
